'use client';
import { useState, ReactNode } from 'react';

interface HoverIconTSXProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  HoverIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  alt: string;
  width: number;
  height: number;
  className?: string;
}

export function HoverIconTSX({
  Icon,
  HoverIcon,
  alt,
  width,
  height,
  className = '',
}: HoverIconTSXProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? (
        <HoverIcon width={width} height={height} />
      ) : (
        <Icon width={width} height={height} />
      )}
    </div>
  );
}
